
import Vue from 'vue';

const VueComponent = Vue.extend({
});
export default class CardknoxGoogleApplePay extends VueComponent {}
